var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 13c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-3A2.47 2.47 0 0 1 0 11.5v-9C0 1.125 1.094 0 2.5 0h3c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-3A1.5 1.5 0 0 0 1 2.5v9c0 .844.656 1.5 1.5 1.5zm10.188-6.687C15.875 6.5 16 6.75 16 7c0 .281-.125.531-.312.719l-4 4a1.01 1.01 0 0 1-1.094.219C10.219 11.78 10 11.406 10 11V9H5.5A1.48 1.48 0 0 1 4 7.5v-1A1.5 1.5 0 0 1 5.5 5H10V3c0-.375.219-.75.594-.906a1.01 1.01 0 0 1 1.094.219zM11 11l3.969-4-4-4L11 6H5.5c-.281 0-.5.25-.5.5v1c0 .281.219.5.5.5H11z"
  })));
};
export default SvgLogout;